import React from 'react';
import { FiPackage, FiDollarSign, FiMessageCircle, FiAlertTriangle, FiAward, FiStar, FiBell, FiChevronRight, FiShield, FiKey, FiUserPlus } from 'react-icons/fi';
import './NotificationItem.css';

const TYPE_CONFIG = {
  order:    { Icon: FiPackage,       color: '#3b82f6', bg: 'rgba(59,130,246,0.08)' },
  payment:  { Icon: FiDollarSign,    color: '#16a34a', bg: 'rgba(22,163,74,0.08)' },
  message:  { Icon: FiMessageCircle, color: '#8b5cf6', bg: 'rgba(139,92,246,0.08)' },
  dispute:  { Icon: FiAlertTriangle, color: '#f59e0b', bg: 'rgba(245,158,11,0.08)' },
  review:   { Icon: FiStar,          color: '#f59e0b', bg: 'rgba(245,158,11,0.08)' },
  trophy:   { Icon: FiAward,         color: '#f59e0b', bg: 'rgba(245,158,11,0.08)' },
  security: { Icon: FiShield,        color: '#f59e0b', bg: 'rgba(245,158,11,0.10)' },
  wallet:   { Icon: FiKey,           color: '#00b248', bg: 'rgba(0,212,18,0.10)'   },
  follow:   { Icon: FiUserPlus,      color: '#3b82f6', bg: 'rgba(59,130,246,0.08)' },
  default:  { Icon: FiBell,          color: '#16a34a', bg: 'rgba(22,163,74,0.08)' },
};

export default function NotificationItem({ message, time, type, read, tradeId, onClick, index = 0 }) {
  const config = TYPE_CONFIG[type] ?? TYPE_CONFIG.default;
  const { Icon } = config;
  const isClickable = !!onClick;

  return (
    <li
      className={`ni ${isClickable ? 'ni-click' : ''} ${read ? 'ni-read' : ''}`}
      role={isClickable ? 'button' : 'listitem'}
      tabIndex={isClickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={e => { if (isClickable && (e.key === 'Enter' || e.key === ' ')) onClick?.(); }}
      aria-label={`${type ?? 'Notificación'}: ${message}`}
      style={{ animationDelay: `${index * 30}ms` }}
    >
      {/* Icon */}
      <div
        className="ni-icon-wrap"
        style={{ background: config.bg, borderColor: config.color + '25' }}
      >
        <Icon className="ni-icon" style={{ color: config.color }} />
      </div>

      {/* Content */}
      <div className="ni-content">
        <p className="ni-message">{message}</p>
        <div className="ni-meta">
          <span className="ni-time">{time}</span>
          {tradeId && (
            <span className="ni-go" style={{ color: config.color }}>
              Ver trade <FiChevronRight className="ni-go-arrow" />
            </span>
          )}
        </div>
      </div>

      {/* Unread dot */}
      {!read && (
        <span className="ni-dot" style={{ background: config.color, boxShadow: `0 0 6px ${config.color}50` }} />
      )}
    </li>
  );
}
